import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3dc9b040&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./mobile.scss?vue&type=style&index=0&id=3dc9b040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc9b040",
  null
  
)

export default component.exports